<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="backStep" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        
        <BoxRegister @saveChange="() => {}"> <!-- arrow function genérica para evitar mensagens de erro no console. -->
            <div class="col-12 mt-4">
                <h4 class="c-ndarkfour bold">
                    Esses são os sócios, administradores e procuradores da empresa.
                </h4>
                <h6 class="c-ndarkfour regular">
                    Já conseguimos a lista de sócios e administradores com base no CNPJ da empresa. Agora, complete os dados de<br>todos eles e adicione os procuradores da empresa, caso possua.
                </h6>
            </div>
            <div class="col-12">
                <TabPartners class="mb-4 pb-2 mt-2" @update-tab="activeTab = $event"/>
            </div>
            <div class="col-12 mb-4 box-partner" v-if="activeTab == 0">
                <button class="col-12 button-dashed mt-0 mb-4" @click="handleNewPartner" v-if="([0, 3].includes($store.state.register.company.cnpj.registerComplete)) && $store.state.register.company.cnpj.isMeiOrEpp">
                    <h6 :class="`c-${getPrimaryColor}four bold mb-0 new`">
                        + Novo sócio
                    </h6>
                </button>
                <PartnerOrProcurator :tableData="partnersList" @requestPartnerProfileChange="handleChangePartnerProfileModal($event)" @requestPartners="requestPartners" />
            </div>
            <div class="col-12 mb-4 box-partner" v-else>

                <PartnerOrProcurator v-show="procuratorList.length" :tableData="procuratorList" @requestPartners="requestPartners" />
                <button class="col-12 button-dashed mt-0" @click="handleNewProcurator" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice || [0, 3].includes($store.state.register.company.cnpj.registerComplete)">
                    <h6 :class="`c-${getPrimaryColor}four bold mb-0 new`" > 
                        + Novo procurador
                    </h6>
                </button>
            </div>
            <div class="col-12 border-top" slot="footer" v-if="!$store.state.user.userAdm && [0, 3].includes($store.state.register.company.cnpj.registerComplete)">
                <div class="d-flex justify-content-end p-4">
                    <Button @click="dialogVisible = true" :disabled="!allRegistersStatusIsComplete || !this.$store.state.register.partners.length" :color="getPrimaryColor">
                        Concluir cadastro
                    </Button>
                </div>
            </div>
        </BoxRegister>
    </div>
    <ConfirmRegisterChange :dialogVisible="dialogVisible" @closeModal="dialogVisible = false"/>
    <PartnerProfile
        :dialogVisible="dialogVisibleUser"
        :partnerProfile="partnerProfile"
        :changePartnerProfile="changingPartnerProfile"
        @closeModal="dialogVisibleUser = false"
        @changePartnerProfile="handleChangePartnerProfile($event)"
    />
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import PartnerOrProcurator from '@/components/tables/PartnerOrProcurator'
import BoxRegister from '@/components/box/BoxRegister'
import getPartners from '@/api/getPartners'
import TabPartners from '@/components/tabs/TabPartners'
import RegisterHeader from '@/components/register/RegisterHeader'
import ConfirmRegisterChange from '@/components/modals/ConfirmRegisterChange'
import PartnerProfile from '@/components/modals/PartnerProfile'
import insertPartner from '@/api/insertPartner'
import insertPartnerPJ from '@/api/insertPartnerPJ'
import deletePartnerPF from '@/api/deletePartnerPF'
import deletePartnerPJ from '@/api/deletePartnerPJ'

export default {
    components: {
        ArrowDropdown,
        PartnerOrProcurator,
        BoxRegister,
        TabPartners,
        RegisterHeader,
        ConfirmRegisterChange,
        PartnerProfile
    },
    data() {
        return {
            activeTab: '',
            dialogVisible: false,
            dialogVisibleUser: false,
            changingPartnerProfile: false,
            partnerProfile: '',
        }
    },
    computed: {
        partnersList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType != 'Procurador' && partners.name)
        },
        procuratorList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType == 'Procurador' && partners.name)
        },
        allRegistersStatusIsComplete() {
            return this.$store.state.register.partners.every(partners => partners.registerComplete == 1)
        }
    },
    methods: {
        handleNewProcurator() {
            const routePrefix = this.$store.state.user.userAdm ? `/partner/${this.$route.params.idCNPJ}` : `/company/register/${this.$route.params.idCNPJ}/partner`
            this.$router.push(`${routePrefix}/procurator/0`)
        },
        handleNewPartner() {
            this.dialogVisibleUser = true
        },
        backStep() {
            if (this.$store.state.user.userAdm) {
                this.$router.push(`/company/provider`)
            } else {
                this.$router.push(`/company`)
            }
        },
        handleChangePartnerProfileModal(newPartnerProfile) {
            this.partnerProfile = newPartnerProfile
            this.changingPartnerProfile = true
            this.dialogVisibleUser = true
        },
        async handleChangePartnerProfile(newPartnerProfile) {
            const partnerProfile = this.$store.state.register.partner
            let response = {}

            if (newPartnerProfile == 'pf' && this.partnerProfile != 'pf') {
                await deletePartnerPJ(partnerProfile.id)
                partnerProfile.id = null
                partnerProfile.associateType = 'Sócio'
                partnerProfile.profession = 'Administrador'
                response = await insertPartner(partnerProfile)
            } else if (newPartnerProfile == 'pj' && this.partnerProfile != 'pj') {
                await deletePartnerPF(partnerProfile.id)
                partnerProfile.id = null
                response = await insertPartnerPJ(partnerProfile)
            }

            this.dialogVisibleUser = false
            if (response.ok) {
                this.$notify({
                    title: 'Tipo de sócio alterado com sucesso',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false
                })
                await getPartners(this.$route.params.idCNPJ)
                this.$store.commit('register/resetPartner')
            }
        },
        async requestPartners() {
            await getPartners(this.$route.params.idCNPJ)
            this.$store.commit('register/resetPartner')
        }
    },
    async created() {
        await getPartners(this.$route.params.idCNPJ)
        this.$store.commit('register/setFormIsChanged', false)
        this.$store.commit('register/resetPartner')
        this.activeTab = this.$store.state.tabs.partnerTab
    }
}
</script>

<style lang="scss" scoped>
h6.new {
    font-size: 14px;
}
</style>
